module.exports = __webpack_public_path__ + "img/mainfloor_bedroom.8ebb7ac7.jpg";